module.exports = __webpack_public_path__ + "static/media/111.b6d8a7f1.png";